import { fetchWithAuth } from './fetchWithAuth'

export async function updateTenantGroup(
  token: string,
  id: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth(`/v1/tenant-groups/${id}`, token, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}
